var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04898 2.70425C9.32247 2.40587 9.7857 2.38601 10.0836 2.65988L15.2904 7.44593C15.4406 7.58398 15.5266 7.77847 15.5275 7.98261C15.5285 8.18675 15.4445 8.38207 15.2957 8.52158L10.0889 13.4022C9.79362 13.679 9.33021 13.6636 9.05384 13.3679C8.77747 13.0722 8.79278 12.6082 9.08805 12.3314L12.9413 8.71952L9.13669 8.71952C8.73226 8.71952 8.4044 8.3912 8.4044 7.98619C8.4044 7.58118 8.73226 7.25285 9.13669 7.25285L12.9145 7.25285L9.09329 3.74039C8.79534 3.46652 8.7755 3.00262 9.04898 2.70425ZM1.48096 7.98619C1.48096 7.58118 1.80881 7.25285 2.21324 7.25285H3.41153C3.81596 7.25285 4.14382 7.58118 4.14382 7.98619C4.14382 8.3912 3.81596 8.71952 3.41153 8.71952H2.21324C1.80881 8.71952 1.48096 8.3912 1.48096 7.98619ZM4.80954 7.98619C4.80954 7.58118 5.13739 7.25285 5.54182 7.25285H6.93983C7.34426 7.25285 7.67211 7.58118 7.67211 7.98619C7.67211 8.3912 7.34426 8.71952 6.93983 8.71952H5.54182C5.13739 8.71952 4.80954 8.3912 4.80954 7.98619Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTo);
export default __webpack_public_path__ + "static/media/to.707776d7.svg";
export { ForwardRef as ReactComponent };